// extracted by mini-css-extract-plugin
export var DialogOverlay = "Modal-module--DialogOverlay--3a4g1";
export var fadeIn = "Modal-module--fadeIn--fKZoP";
export var DialogContent = "Modal-module--DialogContent--2ovTB";
export var CloseButton = "Modal-module--CloseButton--39kB6";